import { render, staticRenderFns } from "./SearchWrittenInstructions.vue?vue&type=template&id=477df4d2&"
import script from "./SearchWrittenInstructions.vue?vue&type=script&lang=js&"
export * from "./SearchWrittenInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports